import { del, get, post, put } from '@api/request';
import _ from 'lodash';

export async function fetchModelLandMethods(
  { appraisalService },
  authenticationToken,
  { type },
) {
  const typeParam = type ? `?type=${type}` : '';
  const url = `${appraisalService}/appraisal/modelland/methods${typeParam}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function fetchModelLands(
  { appraisalService },
  authenticationToken,
  { method, params },
) {
  const queryParam = _.map(
    params,
    param => `${param.name}=${param.value}`,
  ).join('&');
  const url = `${appraisalService}/appraisal/modelland/${method}?${queryParam}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function insertModelLand(
  { appraisalService },
  authenticationToken,
  { method, payload },
) {
  const url = `${appraisalService}/appraisal/modelland/${method}`;
  const { body } = await post(authenticationToken, url, payload);

  return body;
}

export async function fetchModelLand(
  { appraisalService },
  authenticationToken,
  { method, id },
) {
  const url = `${appraisalService}/appraisal/modelland${method}/${id}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function updateModelLand(
  { appraisalService },
  authenticationToken,
  { method, id, payload },
) {
  const url = `${appraisalService}/appraisal/modelland${method}/${id}`;
  const { body } = await put(authenticationToken, url, payload);

  return body;
}

export async function deleteModelLand(
  { appraisalService },
  authenticationToken,
  { method, id },
) {
  const url = `${appraisalService}/appraisal/modelland${method}/${id}`;
  const { body } = await del(authenticationToken, url);

  return body;
}

// model land ranges
export async function fetchModelLandRanges(
  { appraisalService },
  authenticationToken,
  { method, id },
) {
  const url = `${appraisalService}/appraisal/modelland${method}/${id}/ranges`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function fetchModelLandRange(
  { appraisalService },
  authenticationToken,
  { method, id },
) {
  const url = `${appraisalService}/appraisal/modelland${method}range/${id}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function insertModelLandRange(
  { appraisalService },
  authenticationToken,
  { method, id, payload },
) {
  const url = `${appraisalService}/appraisal/modelland${method}/${id}/ranges`;
  const { body } = await post(authenticationToken, url, payload);

  return body;
}

export async function updateModelLandRange(
  { appraisalService },
  authenticationToken,
  { method, id, payload },
) {
  const url = `${appraisalService}/appraisal/modelland${method}range/${id}`;
  const { body } = await put(authenticationToken, url, payload);

  return body;
}

export async function deleteModelLandRange(
  { appraisalService },
  authenticationToken,
  { method, id },
) {
  const url = `${appraisalService}/appraisal/modelland${method}range/${id}`;
  const { body } = await del(authenticationToken, url);

  return body;
}

export async function applyAdjustmentFactor(
  { appraisalService },
  authenticationToken,
  { method, id, payload },
) {
  const url = `${appraisalService}/appraisal/modelland${method}/${id}/applyfactor`;
  const { body } = await put(authenticationToken, url, payload);

  return body;
}

export async function fetchModelLandPricingSchedules(
  { appraisalService },
  authenticationToken,
  { method, id },
) {
  const url = `${appraisalService}/appraisal/modelland${method}/${id}/pricingschedules`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function deleteModelLandPricingSchedule(
  { appraisalService },
  authenticationToken,
  { method, id },
) {
  const url = `${appraisalService}/appraisal/modelland${method}pricingschedule/${id}`;
  const { body } = await del(authenticationToken, url);

  return body;
}

export async function setModelLandPricingScheduleBase(
  { appraisalService },
  authenticationToken,
  { method, id },
) {
  const url = `${appraisalService}/appraisal/modelland${method}pricingschedule/${id}/setbaseunitprice`;
  const { body } = await put(authenticationToken, url);

  return body;
}

export async function insertModelLandPricingSchedule(
  { appraisalService },
  authenticationToken,
  { method, id, pricingID },
) {
  const url = `${appraisalService}/appraisal/modelland${method}/${id}/pricingschedules`;
  const { body } = await post(authenticationToken, url, { pricingID });

  return body;
}
